// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DhYq","col":"styles_col__3hUiR"};